import InfiniteScroll from "infinite-scroll";
import ScrollBooster from "scrollbooster";

if (
    $("ul.pagination").length &&
    -1 === window.location.href.indexOf("/admin")
) {
    $("ul.pagination").closest("nav").hide();
    try {
        document.querySelectorAll(".infinite-scroll").forEach((el) => {
            const parentSelector = "#" + $(el).parent().attr("id") + " ";
            $(parentSelector + "ul.pagination")
                .closest("nav")
                .hide();
            $(".page-load-status").hide();
            document.querySelector(
                parentSelector + ".pagination li.active + li a"
            ) &&
            new InfiniteScroll(el, {
                path: parentSelector + ".pagination li.active + li a",
                append:
                    parentSelector +
                    "div.infinite-scroll .js-live-filter-block-item",
                checkLastPage: true,
                prefill: true,
                responseType: "document",
                outlayer: false,
                scrollThreshold: 100,
                elementScroll: false,
                loadOnScroll: true,
                history: false,
                historyTitle: true,
                hideNav: undefined,
                status: parentSelector + ".page-load-status",
                button: undefined,
                onInit: function () {
                    $(parentSelector + "ul.pagination")
                        .closest("nav")
                        .hide();
                    $(parentSelector + ".page-load-status").hide();
                    this.on("append", function () {
                        $(parentSelector + "ul.pagination")
                            .closest("nav")
                            .hide();
                        $(parentSelector + ".page-load-status").hide();
                    });
                    this.on("load", function () {
                        $(parentSelector + "ul.pagination")
                            .closest("nav")
                            .remove();
                    });
                },
                debug: false,
            });
        });
    } catch (e) {
        console.log(e.message);
    }

    try {
        let collectionInfScrolls = [];
        $(".page-load-status").hide();
        initInfScrolls($(".infinite-scroll-for-tabs").filter(":visible"));

        $("body").on(
            "shown.bs.tab filter.show.tab.content",
            'a[data-toggle="tab"]',
            function (e) {
                setTimeout(() => {
                    collectionInfScrolls = collectionInfScrolls.filter(
                        function (scrollTab) {
                            if (
                                $(
                                    scrollTab.hrefTab +
                                    " .infinite-scroll-for-tabs"
                                )
                                    .first()
                                    .filter(":hidden").length ||
                                (e.type === "filter" &&
                                    scrollTab.hrefTab ===
                                    $(e.target).attr("href"))
                            ) {
                                if (scrollTab.plugin) {
                                    scrollTab.plugin.destroy();
                                }
                                return false;
                            }
                            return true;
                        }
                    );

                    let notInit = true;
                    for (let scrollTab of collectionInfScrolls) {
                        if (scrollTab.hrefTab === $(e.target).attr("href")) {
                            notInit = false;
                            break;
                        }
                    }

                    if (notInit) {
                        initInfScrolls(
                            $(
                                $(e.target).attr("href") +
                                " .infinite-scroll-for-tabs"
                            )
                                .first()
                                .filter(":visible")
                        );
                    }
                }, 1);
            }
        );

        function initInfScrolls($containers) {
            $containers.each(function () {
                const parentSelector = "#" + $(this).parent().attr("id") + " ";

                $(parentSelector + "ul.pagination")
                    .closest("nav")
                    .hide();
                if (
                    document.querySelector(
                        parentSelector + ".pagination li.active + li a"
                    )
                ) {
                    let IS = new InfiniteScroll(this, {
                        path: parentSelector + ".pagination li.active + li a",
                        append:
                            parentSelector +
                            "div.infinite-scroll-for-tabs .js-live-filter-block-item, .infinite-scroll-ajax .js-live-filter-block-item",
                        checkLastPage: true,
                        prefill: true,
                        responseType: "document",
                        outlayer: false,
                        scrollThreshold: 100,
                        elementScroll: false,
                        loadOnScroll: true,
                        history: false,
                        historyTitle: true,
                        hideNav: undefined,
                        status: parentSelector + ".page-load-status",
                        button: undefined,
                        onInit: function () {
                            $(parentSelector + "ul.pagination")
                                .closest("nav")
                                .hide();
                            $(parentSelector + ".page-load-status").hide();
                            this.on("append", function (html) {
                                // Очищаем от дублей классов "infinite-scroll-for-tabs" и "js-live-filter-block-items"
                                $(parentSelector + ".infinite-scroll-for-tabs")
                                    .not(
                                        $(
                                            parentSelector +
                                            ".infinite-scroll-for-tabs"
                                        ).first()
                                    )
                                    .removeClass(
                                        "infinite-scroll-for-tabs js-live-filter-block-items"
                                    );
                                if (
                                    $(html).find(
                                        "ul.pagination li.active + li a"
                                    ).length
                                ) {
                                    $(
                                        parentSelector +
                                        ".infinite-scroll-for-tabs"
                                    ).append(
                                        $(html)
                                            .find("ul.pagination")
                                            .closest("nav")
                                            .get(0).outerHTML
                                    );
                                } else {
                                    IS.destroy();
                                    $(
                                        parentSelector + ".page-load-status"
                                    ).remove();
                                }
                                $(parentSelector + "ul.pagination")
                                    .closest("nav")
                                    .hide();
                                $(parentSelector + ".page-load-status").hide();

                                //region remove html duplicates
                                const seenHrefs = new Set();
                                const items = document.querySelectorAll(parentSelector + '.js-live-filter-block-item');
                                items.forEach(item => {
                                    const link = item.querySelector('.menu-dish-link');
                                    if (link) {
                                        const href = link.getAttribute('href'); // Получаем точный URL

                                        if (seenHrefs.has(href)) {
                                            item.remove(); // Удаляем весь блок, если такой URL уже был
                                        } else {
                                            seenHrefs.add(href); // Запоминаем новый URL
                                        }
                                    }
                                });
                                //endregion

                            });
                            this.on("load", function (body, path, response) {
                                $(parentSelector + "ul.pagination")
                                    .closest("nav")
                                    .remove();
                            });
                        },
                        debug: false,
                    });
                    collectionInfScrolls.push({
                        plugin: IS,
                        hrefTab: "#" + $(this).parent().attr("id"),
                    });
                }
            });
        }
    } catch (e) {
        console.log(e.message);
    }
}

if (document.querySelector(".nowrap")) {
    document.querySelectorAll(".nowrap").forEach((el) => {
        new ScrollBooster({
            viewport: el.parentNode,
            content: el,
            direction: "horizontal",
            onUpdate: (data) => {
                el.style.transform = `translate(
                    ${-data.position.x}px,
                    ${-data.position.y}px
                  )`;
            },
            lockScrollOnDragDirection: "horizontal",
        });
    });
}
if (document.querySelectorAll(".show-on-scroll")) {
    const lazyBlocksObserver = new IntersectionObserver(function (
        entries,
        observer
    ) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                entry.target.classList.add("is-visible");
                lazyBlocksObserver.unobserve(entry.target);
            }
        });
    });

    document.querySelectorAll(".show-on-scroll").forEach((entry) => {
        lazyBlocksObserver.observe(entry);
    });
}
